export const MODALS = {
    PROJECT_PREVIEW: 'PROJECT_PREVIEW',
}
